module.exports = __webpack_public_path__ + "img/pr-9.c3f6114c.png";